(() => {
  const dialog = document.getElementById('mervaux-saved-pieces');
  if (!dialog || typeof dialog.showModal !== 'function' || !window.customElements || customElements.get('mervaux-saved-control')) return;

  const key = 'mervaux:saved-pieces:v1';
  const maximum = 60;
  const copy = dialog.dataset;
  const list = dialog.querySelector('[data-mervaux-saved-list]');
  const empty = dialog.querySelector('[data-mervaux-saved-empty]');
  const statuses = document.querySelectorAll('[data-mervaux-saved-status]');
  if (!list || !empty) return;
  let opener;
  let statusTimer;
  let readFailed = false;

  function productURL(value) {
    if (typeof value !== 'string' || value.length > 1500) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      if (!/^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/)?(?:collections\/[a-z0-9-]+\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return '';
      return url.pathname;
    } catch {
      return '';
    }
  }

  function imageURL(value) {
    if (typeof value !== 'string' || !value || value.length > 2000) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.username || url.password) return '';
      const ownImage = url.origin === window.location.origin && url.pathname.startsWith('/cdn/');
      const shopifyImage = url.protocol === 'https:' && url.host === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/');
      return ownImage || shopifyImage ? url.href : '';
    } catch {
      return '';
    }
  }

  function normalize(piece) {
    if (!piece || typeof piece !== 'object') return null;
    const id = String(piece.id || '');
    const title = typeof piece.title === 'string' ? piece.title.trim().slice(0, 240) : '';
    const url = productURL(piece.url);
    if (!/^\d{1,24}$/.test(id) || !title || !url) return null;
    return { id, title, url, image: imageURL(piece.image) };
  }

  function read() {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw && raw.length > 250000) throw new Error();
      const stored = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(stored)) throw new Error();
      const seen = new Set();
      const valid = [];
      for (const value of stored) {
        const piece = normalize(value);
        if (!piece || seen.has(piece.id)) continue;
        seen.add(piece.id);
        valid.push(piece);
        if (valid.length === maximum) break;
      }
      readFailed = false;
      return valid;
    } catch {
      readFailed = true;
      return null;
    }
  }

  let pieces = read() || [];

  function announce(message) {
    window.clearTimeout(statusTimer);
    for (const status of statuses) {
      status.textContent = dialog.contains(status) === dialog.open ? message : '';
    }
    if (!dialog.open) {
      statusTimer = window.setTimeout(() => {
        for (const status of statuses) status.textContent = '';
      }, 6500);
    }
  }

  function sync(control) {
    if (!control.hasAttribute('data-mervaux-ready')) control.setAttribute('data-mervaux-ready', '');
    const button = control.querySelector('[data-mervaux-save]');
    if (button) {
      const selected = pieces.some((piece) => piece.id === control.dataset.productId);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', copy.saveLabel.replace('__title__', control.dataset.title || ''));
      const label = button.querySelector('[data-mervaux-saved-label]');
      if (label) label.textContent = selected ? copy.savedText : copy.saveText;
      button.hidden = false;
    }
    const open = control.querySelector('[data-mervaux-saved-open]');
    if (open) {
      open.hidden = false;
      open.setAttribute('aria-expanded', String(dialog.open));
      const count = open.querySelector('[data-mervaux-saved-count]');
      if (count) {
        count.textContent = String(pieces.length);
        count.hidden = pieces.length === 0;
      }
    }
  }

  function syncAll() {
    for (const control of document.querySelectorAll('mervaux-saved-control')) sync(control);
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function render() {
    list.replaceChildren();
    empty.hidden = pieces.length !== 0 || readFailed;
    for (const piece of pieces) {
      const item = element('li', 'mervaux-saved-pieces__item');
      const image = element(piece.image ? 'img' : 'span', 'mervaux-saved-pieces__image');
      if (piece.image) {
        image.src = piece.image;
        image.alt = '';
        image.width = 96;
        image.height = 120;
        image.loading = 'lazy';
      } else {
        image.setAttribute('aria-hidden', 'true');
      }
      const detail = element('div', 'mervaux-saved-pieces__detail');
      const title = element('h3', 'mervaux-saved-pieces__title', piece.title);
      const view = element('a', 'mervaux-saved-pieces__view', copy.viewText);
      view.href = piece.url;
      view.setAttribute('aria-label', `${copy.viewText}: ${piece.title}`);
      const remove = element('button', 'mervaux-saved-pieces__remove', copy.removeText);
      remove.type = 'button';
      remove.dataset.mervauxSavedRemove = piece.id;
      remove.setAttribute('aria-label', copy.removeLabel.replace('__title__', piece.title));
      detail.append(title, view, remove);
      item.append(image, detail);
      list.append(item);
    }
  }

  function commit(next, message) {
    try {
      window.localStorage.setItem(key, JSON.stringify(next));
    } catch {
      announce(copy.storageError);
      return false;
    }
    pieces = next;
    syncAll();
    if (dialog.open) render();
    announce(message);
    return true;
  }

  function refresh(renderList = true) {
    const current = read();
    if (current) pieces = current;
    syncAll();
    if (dialog.open && renderList) render();
    if (!current) announce(copy.loadError);
    return current;
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-mervaux-save')) {
      event.preventDefault();
      event.stopPropagation();
      const control = button.closest('mervaux-saved-control');
      if (!control || !refresh()) return;
      const piece = normalize({ id: control.dataset.productId, title: control.dataset.title, url: control.dataset.url, image: control.dataset.image });
      if (!piece) return;
      const selected = pieces.some((entry) => entry.id === piece.id);
      if (!selected && pieces.length >= maximum) {
        announce(copy.limitMessage);
        return;
      }
      const next = selected ? pieces.filter((entry) => entry.id !== piece.id) : [piece, ...pieces];
      commit(next, selected ? copy.removedMessage : copy.savedMessage);
    } else if (button.hasAttribute('data-mervaux-saved-open')) {
      event.preventDefault();
      if (dialog.open) return;
      opener = button;
      refresh();
      render();
      for (const status of statuses) status.textContent = '';
      dialog.showModal();
      syncAll();
      if (readFailed) announce(copy.loadError);
    } else if (button.hasAttribute('data-mervaux-saved-close') && dialog.contains(button)) {
      event.preventDefault();
      dialog.close();
    } else if (button.hasAttribute('data-mervaux-saved-remove') && dialog.contains(button)) {
      event.preventDefault();
      const id = button.dataset.mervauxSavedRemove;
      const previousIndex = pieces.findIndex((piece) => piece.id === id);
      if (!refresh(false)) return;
      if (commit(pieces.filter((piece) => piece.id !== id), copy.removedMessage)) {
        const remaining = list.querySelectorAll('[data-mervaux-saved-remove]');
        const focusTarget = remaining[Math.min(Math.max(previousIndex, 0), remaining.length - 1)] || dialog.querySelector('[data-mervaux-saved-close]');
        focusTarget?.focus();
      }
    }
  }, true);

  dialog.addEventListener('close', () => {
    syncAll();
    for (const status of statuses) status.textContent = '';
    if (opener?.isConnected) opener.focus();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === key || event.key === null) refresh();
  });

  class SavedControl extends HTMLElement {
    static get observedAttributes() {
      return ['data-product-id', 'data-title', 'data-mervaux-ready'];
    }

    connectedCallback() {
      sync(this);
    }

    attributeChangedCallback(name, previous, next) {
      if (!this.isConnected || (name === 'data-mervaux-ready' && next !== null)) return;
      queueMicrotask(() => {
        if (this.isConnected) sync(this);
      });
    }
  }

  customElements.define('mervaux-saved-control', SavedControl);
})();
